import { NotificationsNone, Language, Settings, Search, Logout } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {selectCurrentOffice, setOff} from '../app/officeSlice'
import styled from 'styled-components'
import { useSendLogoutMutation } from "../features/auth/authApiSlice"
import useAuth from "../features/hooks/useAuth"
import { useGetUsersQuery } from '../features/users/usersApiSlice'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import cwclogo from '../images/logo-final.png';
import ashoka from '../images/ashok.png'
import LogoutIcon from '@mui/icons-material/Logout';



const TopContainer = styled.div`
height: 100px;
/* width: 100vw; */
padding: 0 30px;
/* Check for Back Ground colour */
border-bottom:1px solid black;
/* background-color: var(--background-color1); */
background-image: linear-gradient(to right, #a961f1, #57ccf4);  

/* position: fixed; */
z-index: 100;
box-shadow: 1px 1px 15px rgba(161, 182, 253, 0.825);
display: flex;
justify-content: space-between;
align-items: center;    
`
const InnerSection = styled.div`
    display: flex;
    flex: 2;    
`
const MiddleSection = styled.div`
    display: flex;
    flex-direction: column;
    flex: 2;    
`
const TitleText = styled.div`
    font-size: 24px;
    /* width: 60%; */
    color: #58548E;
    font-weight: bold;
    font-family: 'poppinsregular';
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
`
const TextDiv = styled.div`
     display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.2; /* Adjust line height as needed */
    text-align: center;
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 900;
    font-size: 1.07 rem;
    line-height: 1.6;
    letter-spacing: 0.0075em ;

 
`
const Span  =styled.div`
    content: '';
    display: block;
    width: 100%;
    text-align: center;
    margin-top: 5px; /* Adjust spacing between lines */
`

const WelcomeUser = styled.div`
    font-family: "Roboto","Helvetica","Arial",sans-serif;
    font-weight: 500;
    font-size: 1.07 rem;
    line-height: 1.6;
    letter-spacing: 0.0075em ;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
    margin-top: 5px;
    white-space: nowrap;
    color: #626264;
    -webkit-box-flex:1;
`
const LogoImage = styled.img`
    vertical-align:middle;
    border-style:none;
    box-sizing: border-box;
    overflow: hidden;
    visibility:visible;
    width: 90px;
    height: 90px;
`

const AshokaLogo = styled.img`
    vertical-align: middle;
    border-style: none;
    box-sizing: border-box;
    overflow-clip-margin: content-box;
    overflow: clip;
    color: #000;
    font-family: 'Abhaya Libre';
    width: 47px;
    height: 80px;
    margin-left: 60px;

    @media screen and (min-width: 1910px) {
    /* Styles specific to screens larger than 600px */
    vertical-align: middle;
    border-style: none;
    box-sizing: border-box;
    overflow-clip-margin: content-box;
    overflow: clip;
    color: #000;
    font-family: 'Abhaya Libre';
    width: 47px;
    height: 80px;
    margin-left: 200px;
  }
    
`
const LogoText = styled.div`
    box-sizing: border-box;
    display: block;   
`
const LogoTextHeader = styled.h4`
    font-size: 22px;
    padding-left: 10px;
    color: #000;
    line-height: 24px;
    margin-bottom: 0;
    font-weight: bold;
    font-family: 'Abhaya Libre';
    display: block;
    margin-block-start:0.7em;
    margin-block-end:0.7    em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    box-sizing:border-box;
`
const LogoTextSpan = styled.div`
    line-height: 20px;
    color: #000;
    display: block;
    font-family: 'robotoregular';
    font-weight: 400;
    font-size: 16px;
    font-style: italic;
    box-sizing: border-box;
`



const RightLogoTextHeader = styled.h4`
    margin-left: 26px;
    padding-left: 25px;
    margin-bottom: 0;
    font-size: 4px;
    font-weight: bold;
    display: block;
    box-sizing: border-box;
    margin-block-start:0.4em;
    margin-block-end:0.4em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    line-height: 0.8    ;
    color: inherit;
`
const RightPara = styled.p`
    font-size: 13px;
    margin: 0;
    /* line-height: 18px; */
    font-family: 'robotoregular';
    font-weight: 600;
    box-sizing: border-box;
    display: block;
    margin-block-start: 0.5em;
    margin-block-end: 0.5em ;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
`
const TopPara = styled.p`
    font-size: 18px;
    margin: 0;
    /* line-height: 18px; */
    font-family: 'robotoregular';
    font-weight: 600;
    box-sizing: border-box;
    display: block;
    margin-block-start: 0.7em;
    margin-block-end: 0.7em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    `

const LogoutDiv =styled.div`
    margin-left: 50px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items:center;
    cursor:pointer;  
`



const Topbar = () => {
    const Auth = useAuth();
    const navigate = useNavigate();

    const {users} = useGetUsersQuery("usersList", {
    selectFromResult: ({ data }) => ({
      users: data?.entities
    }),
  })

const [sendLogout, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useSendLogoutMutation()

useEffect(() => {
    if (isSuccess){
        navigate('/')
        } 
}, [isSuccess, navigate])

useEffect(() => {
    if (isError) {
        // Even if logout fails, we should clear local state and redirect
        // This ensures user is logged out on frontend even if backend fails
        console.error('Logout failed:', error)
        
        // Force logout on frontend regardless of backend response
        navigate('/')
    }
}, [isError, error, navigate])

  return (
    <TopContainer>

        <InnerSection>
            <LogoImage src={cwclogo}/>
            <LogoText>
                <LogoTextHeader>
                    Central Water Commission
                    <LogoTextSpan>
                    (Serving the nation since 1945)
                    </LogoTextSpan>
                </LogoTextHeader>
            </LogoText>
        </InnerSection>
            

        <MiddleSection>
            <TitleText>
                <TextDiv>
                <Span>Asset Management</Span>
                <Span>System</Span>
                </TextDiv>
            </TitleText>
            {Auth?.id && <WelcomeUser>
                {users? `Welcome, ${Object.values(users).find(x => x.id === Auth.id).name}`:""}
            </WelcomeUser>}

        </MiddleSection>

        <InnerSection>
            <AshokaLogo src={ashoka} />
            <RightLogoTextHeader>                
                <TopPara>Ministry of Jal Shakti</TopPara>
                <RightPara>
                    Department of Water Resources, River
                </RightPara>
                <RightPara>
                    Development &amp; Ganga Rejuvenation
                </RightPara>            
            </RightLogoTextHeader>
            {Auth?.id &&<LogoutDiv onClick={sendLogout}>                
                    <LogoutIcon sx={{fontSize:"35px", color:"red"}} />                
            </LogoutDiv>}									
        </InnerSection>

    </TopContainer>
  )
}

export default Topbar;
